import React, { useEffect, useState } from 'react';
import { Tabs } from '../ui/Tabs';
import { MonthPicker } from '../ui/MonthPicker';

const mesAtual = () => new Date().toISOString().slice(0, 7);

export const MODOS_PERIODO = [
  { id: 'mes', label: 'Mês' },
  { id: 'intervalo', label: 'Jan → Ago' },
  { id: 'ytd', label: 'Este ano até agora' },
  { id: '12m', label: 'Últimos 12 meses' },
  { id: 'ano', label: 'Ano completo' },
];

function resolverIntervalo(modo, { mes, deIntervalo, ateIntervalo, ano }) {
  const atual = mesAtual();
  if (modo === 'mes') return { de: mes || atual, ate: mes || atual };
  if (modo === 'intervalo') return { de: deIntervalo || atual, ate: ateIntervalo || atual };
  if (modo === 'ytd') return { de: `${new Date().getFullYear()}-01`, ate: atual };
  if (modo === '12m') {
    const hoje = new Date();
    const d = new Date(hoje.getFullYear(), hoje.getMonth() - 11, 1);
    return { de: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, ate: atual };
  }
  if (modo === 'ano') return { de: `${ano}-01`, ate: `${ano}-12` };
  return { de: atual, ate: atual };
}

// Seletor de período único, reutilizado em toda tela financeira (Visão
// Geral, Receitas, Despesas, Assinaturas, Cobranças, Relatórios,
// Financeiro do Cliente) — correção pós-QA: cada tela tinha seu próprio
// filtro de competência solto (uns só mês, uns só ano), e "Este mês" do
// dashboard nem deixava trocar de mês. Agora todo lugar tem os mesmos 5
// modos, o mesmo MonthPicker (nunca `<input type="month">` nativo), e
// devolve sempre `{de, ate}` em competência ("YYYY-MM") — quem consome
// decide o que fazer com o intervalo (filtro exato de 1 mês quando
// de===ate, ou intervalo quando são diferentes).
export function PeriodFilterBar({ onChange, anoInicial, modoInicial, mesInicial, deInicial, ateInicial }) {
  // Quando quem chama já sabe o intervalo (ex.: drill-down do dashboard
  // pro Julho→Agosto que a pessoa tinha selecionado), abre direto no modo
  // certo em vez de sempre cair em "Mês atual" — correção do bug em que
  // clicar num número da Visão Geral filtrada num mês antigo abria a tela
  // de destino já no mês vigente.
  const modoPadrao = modoInicial || (deInicial && ateInicial && deInicial !== ateInicial ? 'intervalo' : 'mes');
  const [modo, setModo] = useState(modoPadrao);
  const [mes, setMes] = useState(mesInicial || deInicial || mesAtual());
  const [deIntervalo, setDeIntervalo] = useState(deInicial || mesAtual());
  const [ateIntervalo, setAteIntervalo] = useState(ateInicial || mesAtual());
  const [ano, setAno] = useState(anoInicial || String(new Date().getFullYear()));
  const anos = Array.from({ length: 6 }, (_, i) => String(new Date().getFullYear() + 1 - i));

  const { de, ate } = resolverIntervalo(modo, { mes, deIntervalo, ateIntervalo, ano });

  useEffect(() => { onChange(de, ate, modo); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [de, ate, modo]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--crm-space-3)', flexWrap: 'wrap' }}>
      <Tabs tabs={MODOS_PERIODO} atual={modo} onChange={setModo} />
      {modo === 'mes' && <MonthPicker value={mes} onChange={setMes} />}
      {modo === 'intervalo' && (
        <span style={{ display: 'flex', alignItems: 'center', gap: 'var(--crm-space-2)' }}>
          <MonthPicker value={deIntervalo} onChange={setDeIntervalo} minWidth={130} />
          <span className="crm-form-hint">→</span>
          <MonthPicker value={ateIntervalo} onChange={setAteIntervalo} minWidth={130} />
        </span>
      )}
      {modo === 'ano' && (
        <select className="crm-select" value={ano} onChange={(e) => setAno(e.target.value)} style={{ maxWidth: '110px' }}>
          {anos.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      )}
    </div>
  );
}

export default PeriodFilterBar;
